import React from 'react';
import { package as PackagePropType } from 'lib/CustomPropTypes';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import Promo3Card from './components/Promo3Card';

const Promo3Panel = ({
  content: {
    id, items, packageIndex, metadata: { showTeaseImage } = {},
  } = {}, pkgClassName,
}) => (
  <div className={classNames(pkgClassName, 'clearfix', `pkg-index-${packageIndex + 1}`)}>
    <section
      data-packageid={id}
      className={classNames(
        'promo-3-panel',
        'layout-grid-item grid-col-10-m grid-col-12-l grid-col-push-1-m grid-col-push-0-l',
      )}
    >
      {items.map((item) => {
        if (!item) { return null; }

        const { computedValues: { teaseImage } = {} } = item;
        const dek = (item && item.computedValues && item.computedValues.dek);
        const buttonTitle = (item && item.metadata && item.metadata.ctaText);
        const image = (teaseImage && teaseImage.url && teaseImage.url.primary);
        const itemHideTeaseImage = (
          item && item.metadata && item.metadata.showTeaseImage === false
        );
        const headline = (item && item.computedValues && item.computedValues.headline);
        const buttonUrl = (item && item.metadata && item.metadata.ctaUrl);
        const contentId = (item && item.id);
        const url = (item && item.computedValues && item.computedValues.url);

        return (
          <Promo3Card
            contentId={contentId || ''}
            data-test="promo-three-panel__card"
            key={headline}
            headline={headline || ''}
            dek={dek || ''}
            teaseImage={image || ''}
            buttonUrl={buttonUrl || url}
            buttonTitle={buttonTitle || ''}
            hideTeaseImage={showTeaseImage === false || itemHideTeaseImage}
          />
        );
      })}
    </section>
  </div>
);

Promo3Panel.propTypes = {
  content: PackagePropType.isRequired,
  pkgClassName: PropTypes.string,
};

Promo3Panel.defaultProps = {
  pkgClassName: 'pkg promo3Panel',
};

export default Promo3Panel;
